"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BtnLoad = class BtnLoad extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    action;
    onAction(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("action");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    async act_7315092382398562_script_2276_getActionArgs_value($event) {
        this.$emit('click', $event);
    }
    async act_7315092382398562_script_2276_getActionArgs($event) {
        return {
            value: () => this.act_7315092382398562_script_2276_getActionArgs_value($event),
        };
    }
    async evh_7315092382398562_clickPreventStop(event, scope) {
        return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_script_2276 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7315092382398562_script_2276_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_clickPreventStop_2275 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_script_2276,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_7315092382398562_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_clickPreventStop_2275],
        });
        return {
            act_7315092382398562_script_2276,
            evh_7315092382398562_clickPreventStop_2275,
            evh_7315092382398562_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], BtnLoad.prototype, "action", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('action'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnLoad.prototype, "onAction", null);
BtnLoad = __decorate([
    (0, vue_property_decorator_1.Component)()
], BtnLoad);
exports.default = BtnLoad;
vue_property_decorator_1.Vue.component("BtnLoad", BtnLoad);
